import styled from '@emotion/styled';

const Section = styled('section')(({ variant, spacing, theme: { palette, spacing: themeSpacing } }) => ({
  height: 'auto',
  padding: spacing ? `${spacing * 4}px 0` : `${themeSpacing(7.5, 0)}`,
  background: palette[variant]?.main,
}));

export default Section;
